module.exports = __webpack_public_path__ + "static/climate-6381a3014403f084b99832c16096bde5.gif";